import type { FaireProductEntity } from "../../entity_types/product";

export const p_gpq3p2dduc: FaireProductEntity = {
  token: "p_gpq3p2dduc",
  type: "product",
  name: "Powell Peralta 'support Your Local Skate Shop' T-shirt - Grey",
  brandToken: "b_u8merz42xh",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/61f4af55979b822e86ad12795f13d961c1099f382c44c8df7835089beecfbcbf.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/23f2665fcd753e4fa36df3b00425ad99985aecb26754c08bcccc0236127d0fe9.jpeg",
  ],
  priceDollars: 22.5,
  description:
    "Get ready to show your support in style with the Powell Peralta 'Support Your Local Skate Shop' T-shirt. This soft and pre-shrunk t-shirt features a large back graphic and small left chest graphic, perfect for making a statement. The screen printed logo and inside label add a touch of authenticity to this 100% cotton jersey tee. Support your local skate shop while looking and feeling great!",
  tags: [],
  msrpDollars: 45,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:44.200Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
